// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__Hql1M","label":"Completed_label__1eX63"};